import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useUpdateNotificationPreferences = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const update = async (payload) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.patch("users/me/notification-preferences", payload);
		return res.data?.data;
	};

	return useMutation(update, {
		onSuccess: () => {
			queryClient.invalidateQueries(["notification-preferences"]);
			toast.success("Notification preferences updated");
		},
		onError: (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);
		},
	});
};

export default useUpdateNotificationPreferences;
